import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";

import axios from "@/axios";
import i18n from "@/libs/i18n";
import moment from "moment";
import VuePageTitle from "vue-page-title";
import router from "./router";
import store from "./store";
import App from "./App.vue";

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour";

// Vue page title: https://www.npmjs.com/package/vue-page-title
Vue.use(VuePageTitle);

// Moment.js
Object.defineProperty(Vue.prototype, "$moment", { value: moment });

// Axios Mock Adapter
// import '@/@fake-db/db'

// Assign axios to $http
Vue.prototype.$http = axios;

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// Self-hosted fonts (GDPR compliant — no Google CDN)
require("@fontsource/montserrat/300.css");
require("@fontsource/montserrat/400.css");
require("@fontsource/montserrat/400-italic.css");
require("@fontsource/montserrat/500.css");
require("@fontsource/montserrat/600.css");
require("@fontsource/poppins/300.css");
require("@fontsource/poppins/400.css");
require("@fontsource/poppins/500.css");
require("@fontsource/poppins/700.css");
require("@fontsource/poppins/900.css");

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
